<template>
  <div
    class="m-portlet m-portlet--head-sm"
    :class="{'m-portlet--collapse' : !isOpen }"
    m-portlet="true"
    id="m_portlet_tools_filters"
  >
    <div class="m-portlet__head filters">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">{{ labels.filters }}</h3>
        </div>
      </div>
      <div class="m-portlet__head-tools">
        <ul class="m-portlet__nav">
          <li class="m-portlet__nav-item">
            <a
              @click.prevent="togglePortlet"
              href
              m-portlet-tool="toggle"
              class="m-portlet__nav-link m-portlet__nav-link--icon"
              aria-describedby="tooltip_3xmztoxj1y"
            >
              <i class="la la-angle-down"></i>
            </a>
            <div
              class="m-tooltip m-tooltip--portlet tooltip bs-tooltip-top"
              role="tooltip"
              id="tooltip_3xmztoxj1y"
              aria-hidden="true"
              x-placement="top"
              style="position: absolute; will-change: transform; visibility: hidden; top: 0px; left: 0px; transform: translate3d(288px, -32px, 0px);"
            >
              <div class="tooltip-arrow arrow" style="left: 39px;"></div>
              <div class="tooltip-inner">Expand</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="m-portlet__body" m-hidden-height="345" :style="bodyStyle">
      <div class="row">
        <!-- REFINEMENT LIST -->
        <div v-for="(filter, index) in filters" :id="filter.name" :key="filter.name + index"></div>
      </div>
    </div>
    <div id="topMarker"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { connectRefinementList } from 'instantsearch.js/es/connectors';
import { panel } from 'instantsearch.js/es/widgets';

const refinedList = {};

export default {
  props: ['search'],
  data() {
    return {
      isOpen: true,
      filters: [
        {
          name: 'brandName',
          type: 'choices',
          searchable: true,
        },
        {
          name: 'collectionName',
          type: 'choices',
          searchable: true,
        },
        {
          name: 'categoryName',
          type: 'choices',
          searchable: true,
        },
        {
          name: 'themes',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'typePacks',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'targets',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'areas',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'parentSegmentation',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'subSegmentation',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'typeSkins',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'typeName',
          type: 'choices',
          searchable: true,
        },
        {
          name: 'texturothequeName',
          type: 'choices',
          searchable: true,
        },
        {
          name: 'patentsV2.name',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'ingredientsMix.name',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'ingredientsV2.related_inci',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'rolesMix.name',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'packageCapacities',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'distributionChannels',
          type: 'choices',
          searchable: true,
          optionalOperator: true,
        },
        {
          name: 'countryDistribution',
          type: 'choices',
          searchable: true,
        },
        {
          name: 'commercialized',
          type: 'checkbox',
          hasLabel: true,
        },
        {
          name: 'archived',
          type: 'checkbox',
          hasLabel: true,
        },
        {
          name: 'isLeader',
          type: 'checkbox',
          hasLabel: true,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      selectedProductIds: (store) => store.products.selectedProductIds,
    }),
    bodyStyle() {
      if (!this.isOpen) {
        return 'display: none; overflow: hidden; padding-top: 0px; padding-bottom: 0px;';
      }
      return '';
    },
  },
  methods: {
    ...mapActions('products', ['setSelectedProducts', 'toggleCheckBoxes']),
    togglePortlet() {
      this.isOpen = !this.isOpen;
    },
    renderRefinedFilters() {
      const my = this;
      this.filters.map((filter, index) => {
        refinedList[filter.name] = panel({
          templates: {
            header: my.renderCheckboxInHeader(filter),
          },
          hidden(options) {
            return options.results.nbHits === 0;
          },
        })(my.customRefinementList(filter));

        my.search.addWidget(
          refinedList[filter.name]({
            container: document.getElementById(filter.name),
            attribute: filter.name,
            searchable: filter.searchable,
            searchablePlaceholder: `${my.labels.type_to_search} ${
              my.labels.productFilters[filter.name]
            }`,
            searchableNoResults: my.labels.no_results,
          }),
        );
      });
    },
    customRefinementList(filter) {
      const my = this;
      const renderRefinementList = (renderOptions, isFirstRender) => {
        const {
          items,
          isFromSearch,
          refine,
          searchForItems,
          createURL,
          widgetParams,
        } = renderOptions;

        if (isFirstRender) {
          if (widgetParams.searchable) {
            const input = document.createElement('input');
            const inputAttr = document.createAttribute('class');
            const placeholder = document.createAttribute('placeholder');
            placeholder.value = this.labels.type_to_search;
            inputAttr.value = 'refinementList-search';
            input.setAttributeNode(inputAttr);
            input.setAttributeNode(placeholder);

            input.addEventListener('input', (event) => {
              searchForItems(event.currentTarget.value);
            });

            widgetParams.container.appendChild(input);
          }
          const ul = document.createElement('ul');
          const att = document.createAttribute('class');
          att.value = 'ais-RefinementList-list';
          ul.setAttributeNode(att);
          widgetParams.container.appendChild(ul);
        }

        if (widgetParams.searchable) {
          const input = widgetParams.container.querySelector('input');
          if (!isFromSearch && input.value) {
            input.value = '';
          }
        }

        widgetParams.container.querySelector('ul').innerHTML = items
          .map((item) => {
            if (item.isRefined) {
              return `
                                    <li>
                                      <label class="kt-checkbox">
                                        <input type="checkbox" data-value="${
  item.value
}" checked/>
                                        ${my.translateLabel(
    filter,
    item.label,
  )} (${item.count})
                                        <span></span>
                                      </label>
                                    </li>
                                `;
            }
            return `
                                    <li>
                                      <label class="kt-checkbox">
                                        <input type="checkbox" data-value="${
  item.value
}"/>
                                        ${my.translateLabel(
    filter,
    item.label,
  )} (${item.count})
                                        <span></span>
                                      </label>
                                    </li>
                                `;
          })
          .join('');

        [...widgetParams.container.querySelectorAll('input')].forEach(
          (element) => {
            element.addEventListener('change', (event) => {
              refine(event.currentTarget.dataset.value);
              createURL(event.currentTarget.dataset.value);

              // Deselect any selected products
              if (my.selectedProductIds.length) {
                my.toggleCheckBoxes(false);
                my.setSelectedProducts(null);
              }
            });
          },
        );

        if (this.facetPosition(widgetParams.attribute) >= 0) {
          $(`#${widgetParams.attribute} .and_checkbox`).attr(
            'checked',
            'checked',
          );
        }
      };

      return connectRefinementList(renderRefinementList);
    },
    renderCheckboxInHeader(item, index) {
      if (item.optionalOperator) {
        // Check the input box if the AND operator is selected
        let html = `<label class="kt-checkbox">${
          this.labels.productFilters[item.name]
        } (${
          this.labels.and.toUpperCase()
        }) <input class="and_checkbox" data-name="${
          item.name
        }" data-index="${
          index
        }" type="checkbox"`;
        this.facetPosition(item.name) >= 0
          ? (html += ' checked /><span></span></label>')
          : (html += '/><span></span></label>');
        return html;
      }
      return (
        `<label class="kt-checkbox left">${
          this.labels.productFilters[item.name]
        }</label>`
      );
    },
    facetPosition(filter) {
      return this.search.helper
        ? this.search.helper.state.facets.indexOf(filter)
        : -2;
    },
    translateLabel(filter, label) {
      return filter.hasLabel ? this.labels[label] : label;
    },
  },
  mounted() {
    this.renderRefinedFilters();
    const my = this;
    this.$nextTick(() => {
      $(document).on('click', '.and_checkbox', function (event) {
        const name = $(this).attr('data-name');
        if (my.facetPosition(name) < 0) {
          my.search.helper.state.facets.push(name);
        } else {
          my.search.helper.state.facets.splice(my.facetPosition(name), 1);
        }
      });
    });
  },
  beforeDestroy() {
    $(document).off('click', '.and_checkbox');
  },
};
</script>

<style>
.ais-Panel--collapsible .ais-Panel-collapseButton {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  border: none;
  background: 0 0;
}
.ais-Panel-header {
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #c4c8d8;
}
.ais-Panel-header label {
  margin-bottom: 0;
}
.ais-Panel {
  margin: 10px;
  width: 180px;
  overflow-x: auto;
}
.ais-RefinementList-list {
  list-style: none;
  padding-left: 0px;
  max-height: 250px;
  overflow-y: scroll;
}
.refinementList-search {
  border-radius: 0.2em;
  display: block;
  width: 100%;
  padding: 0.5rem 0.3rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ebedf2;
  outline: none;
  margin-bottom: 3px;
}
.refinementList-search:focus {
  border-color: #ffcc01;
  color: #575962;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.refinementList-search::placeholder {
  color: #9ca0a8;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/AllProducts/Filters.vue